import React from 'react';
import './analytics.css';

/**
 * StatCard - Displays a single metric with optional trend indicator
 *
 * Props:
 *   label      - Metric label (e.g., "Page Views")
 *   value      - Numeric value or string
 *   icon       - Emoji or icon string (optional)
 *   trend      - Percentage change (positive = up, negative = down) (optional)
 *   trendLabel - Label for trend (e.g., "vs last week") (optional)
 *   color      - Accent color for left border (optional, default: #667eea)
 *   loading    - Show loading skeleton (optional)
 *   subtitle   - Small text below value (optional)
 */
export default function StatCard({ label, value, icon, trend, trendLabel, color = '#667eea', loading, subtitle }) {
  if (loading) {
    return (
      <div className="an-stat-card an-stat-card--loading" style={{ borderLeftColor: color }}>
        <div className="an-stat-skeleton an-stat-skeleton--label" />
        <div className="an-stat-skeleton an-stat-skeleton--value" />
      </div>
    );
  }

  const trendDirection = trend > 0 ? 'up' : trend < 0 ? 'down' : 'neutral';
  const trendIcon = trend > 0 ? '↑' : trend < 0 ? '↓' : '–';

  return (
    <div className="an-stat-card" style={{ borderLeftColor: color }}>
      <div className="an-stat-label">
        {icon && <span className="an-stat-icon">{icon}</span>}
        {label}
      </div>
      <div className="an-stat-value">{value ?? '–'}</div>
      {subtitle && <div className="an-stat-subtitle">{subtitle}</div>}
      {trend !== undefined && trend !== null && (
        <div className={`an-stat-trend an-stat-trend--${trendDirection}`}>
          <span className="an-stat-trend-icon">{trendIcon}</span>
          <span className="an-stat-trend-value">{Math.abs(trend)}%</span>
          {trendLabel && <span className="an-stat-trend-label">{trendLabel}</span>}
        </div>
      )}
    </div>
  );
}
